import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle, useCallback} from "react"
import { LoadingOutlined } from '@ant-design/icons';
import ZkModal from "../../../common/modal/zkModal";
import {Input, List, Radio, Select,Spin } from "antd"
import IconSearch from "../../../../iconfont/search";
import allEmpty from "../../image/chat/allEmpty.png"
import contacts from "../../image/chat/contacts.png"
import groupChatEmpty from "../../image/chat/groupChatEmpty.png"
import chattingRecordsEmpty from "../../image/chat/chattingRecordsEmpty.png"
import Util from "../../../public/utils";
import noHead from "../../image/chat/noHead.png"
import IconExternal from "../../iconfont/external/external";
import allAccountHead from "../../../cloud/image/groupChatSop/allAccountHead.png";
import CloudApi from "../../../cloud/cloud_api";
import PubSub from "pubsub-js"
import {withRouter} from "react-router-dom"
import noSearchRelevantContent from "../../image/chatSider/noSearchRelevantContent.png"

let clickTimeChange, contentFlag,chatRecordsLink = false
const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 24,
        }}
        spin
    />
);
import {
    ImAudio,
    ImCard,
    ImFile,
    ImImage,
    ImRecord,
    ImRed,
    ImText,
    ImVideo,
    ImVideoHao,
    ImWxApp
} from "../chatRecord/msgType";
import imLoading from "../../iconfont/loading/imLoading.gif";
import Message from "../../../common/message";


const {Option} = Select
let timer, chatTimer
let pageNum = 1,
    pages = 2,
    total,
    soleId


const GlobalSearch = forwardRef((props, ref) => {
    const [keyword, setKeyword] = useState('')//搜索的关键词
    const [type, setType] = useState('0')//类型
    const [currentAccountId, setCurrentAccountId] = useState(null)//当前活动聊天账号ID
    const [accountId, setAccountId] = useState(null)//账号ID,9全部
    const [accountList, setAccountList] = useState([])//账号列表
    const [data, setData] = useState({})//数据
    const [contentChatRecords, setContentChatRecords] = useState([])//聊天数据
    const [chatRecordsWxid, setChatRecordsWxid] = useState(null)//聊天数据的Wxid
    const [chatRecordsChatWxid, setChatRecordsChatWxid] = useState(null)//聊天数据的ChatWxid
    const [loading, setLoading] = useState(true)
    const [chatRecordType, setChatRecordType] = useState(null)//聊天记录类型
    // const [chatMessageId, setChatMessageId] = useState(null)//存放外面多条聊天记录点击进来的id
    const GlobalSearchRef = useRef(null) //全局搜素的弹框

    const options = [
        {label: '全部', value: '0'},
        {label: '联系人', value: '1'},
        {label: '群聊', value: '2'},
        {label: '聊天记录', value: '3'},
    ];
    useEffect(() => {}, [data, keyword])

    useImperativeHandle(ref, () => ({
        openGlobalSearchModal: openGlobalSearchModal,
    }))

    //请求全局搜索的内容
    function getSearchCount(bodyData) {
        if (bodyData.keyword != '') {
            CloudApi.chetMsgSearch(bodyData, (list) => {
                if (soleId == list.randomString) {
                    let newData = list
                    let newChatWxId, newAccountId
                    if (newData.msgList && newData.msgList.length > 0) {
                        if (bodyData.accountId != 9 && bodyData.accountId != bodyData.currentAccountId) {
                            newData.msgList.forEach(item => {
                                if (item.id == bodyData.currentAccountId) {
                                    item.flag = true
                                }
                            })
                            newChatWxId = bodyData.currentAccountId
                            newAccountId = bodyData.accountId
                        } else {
                            newData.msgList[0].flag = true
                            newChatWxId = newData.msgList[0].id
                            newAccountId = newData.msgList[0].accountId
                        }
                    }
                    if (bodyData.type == 3) {
                        if (newData.msgList && newData.msgList.length > 0) {
                            // console.log(bodyData.type, newData.msgList[0], keyword, '121212')
                            setChatRecordsWxid(newData.msgList[0].accountId) //获取聊天数据第一条的wxid
                            setChatRecordsChatWxid(bodyData.currentAccountId ? bodyData.currentAccountId : newData.msgList[0].id) //获取聊天数据第一条的wxid
                            getContentChatRecords({
                                keyword: bodyData.keyword,
                                chatWxId: newChatWxId,
                                accountId: newAccountId,
                                msgType: 9
                            })
                        }
                    }
                    contentFlag = false
                    setData(newData)
                    setChatRecordType(newData.msgList[0].type)
                }
            }, () => {
            })
        } else {
            setData({})
            setContentChatRecords([])
        }
    }

    //请求聊天内容
    function getContentChatRecords(bodyData) {
        setLoading(true)
        let queryParam = {
            pageNum: pageNum,
            pageSize: 20,
        }
        CloudApi.getChatRecordList(queryParam, bodyData, (data) => {
            // console.log(data,'data')
            pages = data.pagInfo.pages
            total = data.pagInfo.total
            setLoading(false)
            // console.log(data.accountId,'saddfads')
            setChatRecordsWxid(data.accountId) //联系人id
            setChatRecordsChatWxid(data.chatWxId) //会话id
            setChatRecordType(data.type) //会话类型
            setContentChatRecords(data.list)
        }, () => {
            setLoading(true)
        })
    }

    //每次打开弹框 点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
    function openGlobalSearchModal(type, keyword, accountId, currentAccountId) {
        soleId = Util.randomString()
        CloudApi.getChatAccountList((data) => {
            if (data.list.length > 0) {
                setAccountList(data.list)
            }
        }, () => {
        })
        setAccountId(accountId)//账号ID,9全部
        setCurrentAccountId(currentAccountId)//当前活动聊天账号ID
        if (type) {
            setType(type) //类型
        } else {
            setType('0')
        }
        if (keyword) {
            setKeyword(keyword) //关键词
        } else {
            setKeyword('')
        }
        getSearchCount({ //请求搜索聊天的接口
            keyword: keyword,
            type: type,
            accountId: accountId,
            currentAccountId: currentAccountId,
            randomString: soleId
        })
        GlobalSearchRef.current.show()
    }

    //单选按钮的事件
    function radioChange(e) {
        soleId = Util.randomString()
        let value = e.target.value
        setType(value)
        if(keyword == ''){
            contentFlag = false
        }else {
            contentFlag = true
        }
        getSearchCount({
            keyword,
            type: value,
            accountId,
            currentAccountId,
            randomString: soleId
        })
    }

    //显示全部联系人
    function showAllLinkman() {
        soleId = Util.randomString()
        getSearchCount({ //请求搜索聊天的接口
            keyword: keyword,
            type: 1,
            accountId: accountId,
            currentAccountId: currentAccountId,
            randomString: soleId
        })
        setType('1')
    }

    //显示全部群聊
    function showAllGroup() {
        soleId = Util.randomString()
        getSearchCount({ //请求搜索聊天的接口
            keyword: keyword,
            type: 2,
            accountId: accountId,
            currentAccountId: currentAccountId,
            randomString: soleId
        })
        setType('2')
    }

    //显示全部聊天记录
    function showAllChattingRecords() {
        soleId = Util.randomString()
        getSearchCount({ //请求搜索聊天的接口
            keyword: keyword,
            type: 3,
            accountId: accountId,
            currentAccountId: currentAccountId,
            randomString: soleId
        })
        setType('3')
    }

    //搜索关键词的输入事件
    function keywordChange(e) {
        soleId = Util.randomString()
        let value = e.target.value
        if (value == '') {
            contentFlag = false
        } else {
            contentFlag = true
        }
        setKeyword(value)
        clearTimeout(timer)
        timer = setTimeout(() => {
            getSearchCount({ //请求搜索的接口
                keyword: value,
                type: type,
                accountId: accountId,
                currentAccountId: currentAccountId,
                randomString: soleId
            })
        }, 200)
    }


    //切换联系人id的事件
    function cutAccountId(e) {
        soleId = Util.randomString()
        setAccountId(e)
        if(keyword == ''){
            contentFlag = false
        }else {
            contentFlag = true
        }
        getSearchCount({ //请求搜索的接口
            keyword: keyword,
            type: type,
            accountId: e,
            currentAccountId: currentAccountId,
            randomString: soleId
        })
    }

    //跳转
    function jumpOtherNumber(accountId, friendId) {
        let newData = accountList
        let flag = newData.some(item=>item.wxid == accountId)
        if(flag){
            newData.forEach((item, index) => {
                if (item.wxid == accountId) {
                    PubSub.publish('SWITCHING_CONTACTS_ON_THE_LEFT', {item, index})
                    props.modificationChatWxid(accountId, friendId)
                    chatRecordsLink=flag
                }
            })
        }else {
            chatRecordsLink=false
            Message.warning('该会话相关联的企微号没有开启聊天功能！')
        }
    }

    //点击全部下面的联系人
    function clickAllContacts(accountId, friendId, type) {
        let wxid = Util.getUrlArg('wxid')
        if (wxid == accountId) { //判断点击的这个和路由id是不是同一个人
            props.clickJump(accountId, friendId, type)   //联系人的会话切换  跳转
            GlobalSearchRef.current.hide() //关闭弹框
        } else {
            jumpOtherNumber(accountId, friendId)//左侧联系人切换
            if(chatRecordsLink == true){
                props.clickJump(accountId, friendId, type)//联系人的会话切换
                GlobalSearchRef.current.hide() //关闭弹框
            }
        }
    }

    //查看聊天内容
    function viewChatContent(singleData, index) {
        // clearTimeout(clickTimeChange)
        // clickTimeChange = setTimeout(() => {
            pageNum = 1
            let newData = JSON.parse(JSON.stringify(data))
            newData.msgList && newData.msgList.forEach((item,ind) => {
                item.flag = false
                if (item.id == singleData.id) {
                    item.flag = true
                    // setChatRecordsWxid(item.accountId)
                    // setChatRecordsChatWxid(item.id)
                    setContentChatRecords([])
                }
            })
            setData(newData)
            getContentChatRecords({
                keyword: keyword,
                chatWxId: newData.msgList[index].id,
                accountId: newData.msgList[index].accountId,
                msgType: 9
            })
        // })
    }

    function handleScroll() {
        clearTimeout(chatTimer)
        let scroll = document.querySelector('.chatting_records_style');
        let clientHeight = scroll.clientHeight  // 可视区域
        let scrollTop = scroll.scrollTop  //当前位置 最上面0
        let scrollHeight = scroll.scrollHeight //总高
        if (scrollHeight - (scrollTop + clientHeight) < 50 && pageNum < pages && clientHeight != scrollHeight) {
            chatTimer = setTimeout(() => {
                pageNum = pageNum + 1
                let bodyData = {
                    keyword: keyword,
                    chatWxId: chatRecordsChatWxid,
                    accountId: chatRecordsWxid,
                    msgType: 9
                }

                setLoading(true)
                let queryParam = {
                    pageNum: pageNum,
                    pageSize: 20,
                }
                CloudApi.getChatRecordList(queryParam, bodyData, (data) => {
                    pages = data.pagInfo.pages
                    total = data.pagInfo.total
                    setLoading(false)
                    setChatRecordsWxid(data.accountId) //联系人id
                    setChatRecordsChatWxid(data.chatWxId) //会话id
                    setChatRecordType(data.type) //会话类型
                    setContentChatRecords([...contentChatRecords, ...data.list])
                }, () => {
                    setLoading(true)
                })
            }, 500)
        }
    }


    //点击聊天记录的内容
    function chatHistoryClick(item) {
        soleId = Util.randomString()
        if (item.msgNum > 1) {
            getSearchCount({ //请求搜索聊天的接口
                keyword: keyword,
                type: 3,
                accountId: item.accountId,
                currentAccountId: item.id,
                randomString: soleId
            })
            setType('3')
        } else {
            // props.clickJump(item.accountId, item.id, 3)//联系人的会话切换
            clickAllContacts(item.accountId, item.id, item.type)

        }
    }

    //聊天记录的跳转
    function chatJump(item) {
        // console.log(chatRecordsWxid, chatRecordsChatWxid,'asdasdasdasddddd')
        clickAllContacts(chatRecordsWxid, chatRecordsChatWxid, chatRecordType)
    }


    return (
        <>
            {React.Children.map(props.children, child => React.cloneElement(child))}
            <ZkModal
                width={688}
                ref={GlobalSearchRef}
                footer={null}
                className={'modal-right-btn im-setting-modal global_search_box'}
                afterClose={() => {
                    setType('0')
                    if (props.inputRef) {
                        props.inputRef()
                    }
                }}
                title={<div className={'global_modal_title'}>
                    <Input prefix={<IconSearch/>}
                           placeholder={'搜索'}
                           value={keyword}
                           onChange={keywordChange}
                           style={{fontSize: '12px'}}
                    />
                    <Select value={accountId} onChange={cutAccountId.bind(this)}>
                        <Option value={9} key={9} style={{fontSize: '12px'}}>
                            <img src={allAccountHead} style={{width: '20px', borderRadius: '50%'}}/>&nbsp;全部账号
                        </Option>
                        {
                            accountList.length > 0 ?
                                <>
                                    {
                                        accountList.map((item, index) => {
                                            return <Option key={item.wxid} value={item.wxid}>
                                                <img src={item.avatar}
                                                     style={{width: '20px', borderRadius: '50%'}}/>&nbsp;{item.nickname}
                                            </Option>
                                        })
                                    }
                                </> : ''
                        }
                        {accountList.length > 0 ?
                            <Option value={0} disabled={true} className={'opt_disabled'}>
                                <div className={'no_more_data'} style={{fontSize: '12px'}}>没有更多了~</div>
                            </Option>
                            : ''
                        }
                    </Select>
                </div>}
            >
                <div className={'global_modal_content'}>
                    <div className={'global_modal_content_radio'}>
                        <Radio.Group
                            buttonStyle="solid"
                            options={options}
                            onChange={radioChange}
                            value={type}
                            optionType="button"
                        />
                    </div>
                    {
                        contentFlag ? <div className={'global_modal_content_type'}
                                           style={{display:'flex',alignItems: 'center',justifyContent:'center'}}>
                                <Spin indicator={antIcon} />
                        </div> :
                            <div className={'global_modal_content_type'}>
                                {
                                    type == 0 ?
                                        <div className={'global_modal_content_all'}>
                                            {JSON.stringify(data) == '{}' ?
                                                <img src={allEmpty} className={'global_modal_content_empty'}/> :
                                                <div className={'all_link_man'}>
                                                    <>{(data.friendList && data.friendList.length == 0) && (data.roomList && data.roomList.length == 0) && (data.msgList && data.msgList.length == 0) ?
                                                        <div className={'no_search_relevant_content'}><img
                                                            src={noSearchRelevantContent}/></div> : <>
                                                            {data.friendList && data.friendList.length > 0 ?
                                                                <ul>
                                                    <span style={{
                                                        paddingLeft: '24px',
                                                        boxSizing: 'border-box'
                                                    }}>联系人</span>
                                                                    {data.friendList && data.friendList.map((item, index) => {
                                                                        if (index < 3) {
                                                                            return <li key={index}
                                                                                       onClick={clickAllContacts.bind(this, item.accountId, item.friendId, 1)}>
                                                                                {
                                                                                    item.avatar ?
                                                                                        <img src={item.avatar}/> :
                                                                                        <img src={noHead}/>
                                                                                }
                                                                                <div>
                                                                    <span style={{display:'flex',alignItems:'center'}}>
                                                                        <span
                                                                            style={{maxWidth: '400px'}}
                                                                            className={'left_link_man_name_style'}
                                                                            dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                        {item.friendType == 1 ?
                                                                            <span className={'wx_name'}
                                                                                  style={{
                                                                                      fontSize: '12px',
                                                                                      marginLeft: '2px'
                                                                                  }}>@微信</span> : ''}
                                                                    </span>
                                                                                    <span style={{display:'flex',alignItems:'center'}}>
                                                                        {item.friendType == 1 ? <span>微信昵称：</span> : ''}
                                                                                        <span
                                                                                            style={{maxWidth: '400px'}}
                                                                                            className={'left_link_man_name_style'}
                                                                                            dangerouslySetInnerHTML={{__html: Util.textHightLight(item.friendType == 0 ? item.corpName || '' : item.friendType == 1 ? item.nickName || '' : '', keyword)}}></span>
                                                                    </span>
                                                                                </div>
                                                                            </li>
                                                                        }
                                                                    })}
                                                                    {
                                                                        data.friendList && data.friendList.length >= 3 ?
                                                                            <span className={'reverl_all'}
                                                                                  style={{
                                                                                      color: '#1673FF',
                                                                                      boxSizing: 'border-box'
                                                                                  }}
                                                                                  onClick={showAllLinkman}>显示全部</span> : ''
                                                                    }
                                                                    <div className={'global_search_line'}></div>
                                                                </ul> : ''}
                                                            {
                                                                data.roomList && data.roomList.length > 0 ?
                                                                    <ul>
                                                        <span style={{
                                                            marginTop: '14px',
                                                            paddingLeft: '24px',
                                                            boxSizing: 'border-box'
                                                        }}>群聊</span>
                                                                        {data.roomList && data.roomList.map((item, index) => {
                                                                            if (index < 3) {
                                                                                return <li key={index}
                                                                                           onClick={clickAllContacts.bind(this, item.accountId, item.roomId, 2)}
                                                                                >
                                                                                    {
                                                                                        item.avatar ?
                                                                                            <img src={item.avatar}/> :
                                                                                            <img src={noHead}/>
                                                                                    }
                                                                                    <div>
                                                                        <span style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            <span style={{maxWidth: '200px'}}
                                                                                  className={'left_link_man_name_style'}
                                                                                  dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                            {item.memberNum ?
                                                                                <span
                                                                                    className={'group_member_num'}>（{item.memberNum}）</span> : ''}
                                                                            {item.roomType == 0 ?
                                                                                <span></span> : item.roomType == 1 ?
                                                                                    <span
                                                                                        className={'external_icon'}><IconExternal/></span> : ''}
                                                                        </span>
                                                                                        <span>
                                                                            {item.memberName != '' ? '包含：' : ''}
                                                                                            <span
                                                                                                dangerouslySetInnerHTML={{__html: Util.textHightLight(item.memberName || '', keyword)}}></span>
                                                                        </span>
                                                                                    </div>
                                                                                </li>
                                                                            }
                                                                        })}
                                                                        {
                                                                            data.roomList && data.roomList.length >= 3 ?
                                                                                <span className={'reverl_all'}
                                                                                      style={{
                                                                                          color: '#1673FF',
                                                                                          boxSizing: 'border-box'
                                                                                      }}
                                                                                      onClick={showAllGroup}>显示全部</span> : ''
                                                                        }
                                                                        <div className={'global_search_line'}></div>
                                                                    </ul> : ''
                                                            }
                                                            {
                                                                data.msgList && data.msgList.length > 0 ?
                                                                    <ul>
                                                        <span style={{
                                                            marginTop: '14px',
                                                            paddingLeft: '24px',
                                                            boxSizing: 'border-box'
                                                        }}>聊天记录</span>
                                                                        {data.msgList && data.msgList.map((item, index) => {
                                                                            if (index < 3) {
                                                                                return <li key={index}
                                                                                           onClick={chatHistoryClick.bind(this, item)}>
                                                                                    {
                                                                                        item.avatar ?
                                                                                            <img src={item.avatar}/> :
                                                                                            <img src={noHead}/>
                                                                                    }
                                                                                    <div style={{height:'42px'}}>
                                                                                <span
                                                                                    style={{maxWidth: '200px'}}
                                                                                    className={'left_link_man_name_style'}
                                                                                    dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                                        <span>{item.msgNum}条相关聊天记录</span>
                                                                                    </div>
                                                                                </li>
                                                                            }
                                                                        })}
                                                                        {
                                                                            data.msgList && data.msgList.length >= 3 ?
                                                                                <span className={'reverl_all'}
                                                                                      style={{
                                                                                          color: '#1673FF',
                                                                                          boxSizing: 'border-box'
                                                                                      }}
                                                                                      onClick={showAllChattingRecords}>显示全部</span> : ''
                                                                        }
                                                                        <div className={'global_search_line'}></div>
                                                                    </ul> : ''
                                                            }
                                                        </>}</>

                                                </div>
                                            }
                                        </div> :
                                        type == 1 ?
                                            <div className={'global_modal_content_all'}>
                                                {JSON.stringify(data) == '{}' ?
                                                    <img src={contacts} className={'global_modal_content_empty'}/> :
                                                    data.friendList && data.friendList.length > 0 ?
                                                        <div className={'all_link_man'}>
                                                            <ul style={{marginTop: '5px', borderBottom: 'none'}}>
                                                                {
                                                                    data.friendList && data.friendList.map((item, index) => {
                                                                        return <li key={index}
                                                                                   onClick={clickAllContacts.bind(this, item.accountId, item.friendId, 1)}>
                                                                            {
                                                                                item.avatar ? <img src={item.avatar}/> :
                                                                                    <img src={noHead}/>
                                                                            }
                                                                            <div>
                                                                        <span style={{display:'flex',alignItems:'center'}}>
                                                                            <span
                                                                                style={{maxWidth: '200px'}}
                                                                                className={'left_link_man_name_style'}
                                                                                dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                            {item.friendType == 1 ?
                                                                                <span className={'wx_name'}
                                                                                      style={{fontSize: '12px',marginLeft:'3px'}}>@微信</span> : ''}
                                                                        </span>
                                                                                <span style={{display:'flex',alignItems:'center'}}>
                                                                            {item.friendType == 1 ?
                                                                                <span>微信昵称：</span> : ''}
                                                                                    <span
                                                                                        style={{maxWidth: '200px'}}
                                                                                        className={'left_link_man_name_style'}
                                                                                        dangerouslySetInnerHTML={{__html: Util.textHightLight(item.friendType == 0 ? item.corpName || '' : item.friendType == 1 ? item.nickName || '' : '', keyword)}}></span>
                                                                        </span>
                                                                            </div>
                                                                        </li>
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                        : <img src={noSearchRelevantContent}
                                                               className={'global_modal_content_empty'}/>}
                                            </div> :
                                            type == 2 ?
                                                <div className={'global_modal_content_all'}>
                                                    {JSON.stringify(data) == '{}' ?
                                                        <img src={groupChatEmpty}
                                                             className={'global_modal_content_empty'}/> :
                                                        data.roomList && data.roomList.length > 0 ?
                                                            <div className={'all_link_man'}>
                                                                <ul style={{marginTop: '5px', borderBottom: 'none'}}>
                                                                    {
                                                                        data.roomList && data.roomList.map((item, index) => {
                                                                            return <li key={index}
                                                                                       onClick={clickAllContacts.bind(this, item.accountId, item.roomId, 2)}>
                                                                                {
                                                                                    item.avatar ?
                                                                                        <img src={item.avatar}/> :
                                                                                        <img src={noHead}/>
                                                                                }
                                                                                <div>
                                                                        <span style={{display:'flex',alignItems:'center'}}>
                                                                            <span
                                                                                style={{maxWidth: '200px'}}
                                                                                className={'left_link_man_name_style'}
                                                                                dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                            {item.memberNum ?
                                                                                <span
                                                                                    className={'group_member_num'}>（{item.memberNum}）</span> : ''}
                                                                            {item.roomType == 0 ?
                                                                                <span></span> : item.roomType == 1 ?
                                                                                    <span
                                                                                        className={'external_icon'}><IconExternal/></span> : ''}
                                                                        </span>
                                                                                    <span style={{display:'flex',alignItems:'center'}}>
                                                                            {item.memberName != '' ? '包含：' : ''}
                                                                                        <span
                                                                                            style={{maxWidth: '200px'}}
                                                                                            className={'left_link_man_name_style'}
                                                                                            dangerouslySetInnerHTML={{__html: Util.textHightLight(item.memberName || '', keyword)}}></span>
                                                                        </span>
                                                                                </div>
                                                                            </li>
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div> :
                                                            <img src={noSearchRelevantContent}
                                                                 className={'global_modal_content_empty'}/>}
                                                </div> :
                                                type == 3 ?
                                                    <div className={'global_modal_content_all'}>
                                                        {JSON.stringify(data) == '{}' ?
                                                            <img src={chattingRecordsEmpty}
                                                                 className={'global_modal_content_empty'}/> :
                                                            data.msgList && data.msgList.length > 0 ?
                                                                <div className={'all_link_man'} style={{
                                                                    padding: '0 24px',
                                                                    boxSizing: 'border-box'
                                                                }}>
                                                                    <div className={'chat_history_page'}>
                                                                        <ul className={'chat_history_page_left'}>
                                                                            {data.msgList && data.msgList.map((item, index) => {
                                                                                return <li key={index}
                                                                                           onClick={viewChatContent.bind(this, item, index)}
                                                                                           className={item.flag ? 'chat_list_background' : ''}>
                                                                                    <img src={item.avatar}/>
                                                                                    {
                                                                                        item.type == 1 ?
                                                                                            <div>
                                                                                        <span>
                                                                                            <span
                                                                                                className={'single_chat_name'}
                                                                                                dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                                            {
                                                                                                item.friendType == 1 ?
                                                                                                    <span
                                                                                                        className={'wx_name'}
                                                                                                        style={{fontSize: '12px'}}>@微信</span> : ''
                                                                                            }
                                                                                        </span>
                                                                                                <span style={{maxWidth: '160px'}}
                                                                                                      className={'left_link_man_name_style'}>
                                                                                            {item.friendType == 0 ? <>{item.corpName}</> : item.friendType == 1 ? <>{item.nickName}</> : ''}
                                                                                        </span>
                                                                                            </div> :
                                                                                            item.type == 2 ?
                                                                                                <div>
                                                                                            <span
                                                                                                className={'group_chat_name'}
                                                                                                dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', keyword)}}></span>
                                                                                                    <span>{item.msgNum}条相关聊天记录</span>
                                                                                                </div> : ''
                                                                                    }
                                                                                </li>
                                                                            })}
                                                                        </ul>
                                                                        <div className={'chat_history_page_right'}>
                                                                            {
                                                                                total != null ?
                                                                                    <div className={'title_relevant_record'}>
                                                                                        <div>
                                                                                            <span style={{maxWidth: '200px'}}
                                                                                                  className={'left_link_man_name_style'}>{total}条与“{keyword}”的相关记录</span>
                                                                                            <a onClick={chatJump}>进入会话</a>
                                                                                        </div>
                                                                                    </div> : ''
                                                                            }
                                                                            <List
                                                                                className={'chatting_records_style'}
                                                                                loading={pageNum == 1 && loading ? true : false}
                                                                                itemLayout="horizontal"
                                                                                id={'im-record-words'}
                                                                                onScroll={handleScroll}
                                                                                dataSource={contentChatRecords}
                                                                                renderItem={(item, index) => (
                                                                                    <>
                                                                                        <List.Item
                                                                                            style={{cursor: 'pointer'}}
                                                                                            key={item.content.msg_unique_identifier + item.content.timestamp}
                                                                                        >
                                                                                            {
                                                                                                item.type == 2 || item.type == 0 ?
                                                                                                    <ImText data={item}
                                                                                                            keyword={keyword}/> :
                                                                                                    item.type == 23 || item.type == 103 ?
                                                                                                        <ImVideo
                                                                                                            data={item}
                                                                                                            wxid={chatRecordsWxid}/> :
                                                                                                        item.type == 14 || item.type == 101 || item.type == 29 ?
                                                                                                            <ImImage
                                                                                                                data={item}
                                                                                                                wxid={chatRecordsWxid}/> :
                                                                                                            item.type == 15 || item.type == 102 ?
                                                                                                                <ImFile
                                                                                                                    data={item}
                                                                                                                    wxid={chatRecordsWxid}/> :
                                                                                                                item.type == 41 ?
                                                                                                                    <ImCard
                                                                                                                        data={item}/> :
                                                                                                                    item.type == 78 ?
                                                                                                                        <ImWxApp
                                                                                                                            data={item}/> :
                                                                                                                        item.type == 26 ?
                                                                                                                            <ImRed
                                                                                                                                data={item}/> :
                                                                                                                            item.type == 4 ?
                                                                                                                                <ImRecord
                                                                                                                                    data={item}/> :
                                                                                                                                item.type == 16 ?
                                                                                                                                    <ImAudio
                                                                                                                                        data={item}
                                                                                                                                        wxid={chatRecordsWxid}/> :
                                                                                                                                    item.type == 141 ?
                                                                                                                                        <ImVideoHao
                                                                                                                                            data={item}/> : ''
                                                                                            }
                                                                                        </List.Item>
                                                                                        {
                                                                                            index == contentChatRecords.length - 1 && pageNum < pages ?
                                                                                                <div
                                                                                                    className={'record-msg-loading'}
                                                                                                    style={{visibility: !loading ? '' : 'hidden'}}>
                                                                                                    <img
                                                                                                        src={imLoading}/>
                                                                                                </div> : ''
                                                                                        }
                                                                                        {/*{*/}
                                                                                        {/*    index == contentChatRecords.length - 1 && !loading && pageNum == pages ?*/}
                                                                                        {/*        <div*/}
                                                                                        {/*            className={'record-msg-loading'}>没有更多了</div> : ''*/}
                                                                                        {/*}*/}
                                                                                    </>
                                                                                )}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div> :
                                                                <img src={noSearchRelevantContent}
                                                                     className={'global_modal_content_empty'}/>}
                                                    </div> : ''
                                }
                            </div>
                    }

                </div>
            </ZkModal>
        </>
    )
})
export default GlobalSearch